import FlipMove from "react-flip-move";
import React from "react";

const ProjectUsersTable = ({children,className = '',animationProps = {leaveAnimation:"none"}, ...props}) => {

    return (
        <table className={"table border " + className}>
            {/* <thead className="thead-light">
            <tr>
                <th className="text-left py-1" style={{width: "30%"}}>Name</th>
                <th className="text-left py-1" style={{width: "35%"}}>Email</th>
                <th className="py-1"></th> */}
            {/* Adding column for alignment */}
            {/* <th className="py-1"></th>
            </tr>
            </thead> */}
            <FlipMove
                {...animationProps}
                staggerDurationBy={20}
                style={{ fontSize: 12 }}
                typeName="tbody"
            >
                {children}
            </FlipMove>
        </table>
    )
}
export default ProjectUsersTable